// @flow
import { Map as ImmutableMap, Record } from 'immutable';
import type { RecordFactory, RecordOf } from 'immutable';

import type { QcsSyncResourceStoreProps } from 'data/qcsSyncResourceTypes';

type TripsStoreProps = QcsSyncResourceStoreProps & {};
export const mkTripsStore: RecordFactory<TripsStoreProps> =
  Record({
    resourcesById: ImmutableMap(),

    lastSyncDate: undefined,
    loadPending: true,

    isLoading: false,
    pendingAmount: undefined,
  });

// ////////////////////////////////////////////////////////////////////////////////////////////////
// Trip - Base Trip Properties
// ////////////////////////////////////////////////////////////////////////////////////////////////

type TripProps = {
  id: string,
  clientId: ?string,
  isDeleted: ?boolean,
  modifiedAt: ?number,

  vehicleId: string,
  startTripOn: string,
  endTripOn: string,
  purpose: string,
  type: string, // 'PERSONAL' or 'BUSINESS'
  startLocation: string,
  endLocation: string,
  odometerStart: number,
  odometerEnd: number,
  distance: number,  // calculated by QCS
  otherCosts: number,
}

export type Trip = RecordOf<TripProps>;


// ================================================================================================
// Save for __________  Properties & Types
// ================================================================================================

export const mkTrip: RecordFactory<TripProps> =
  Record({
    id: undefined,
    clientId: undefined,
    isDeleted: false,
    modifiedAt: undefined,

    vehicleId: undefined,
    startTripOn: undefined,
    endTripOn: undefined,
    purpose: undefined,
    type: 'BUSINESS',
    startLocation: undefined,
    endLocation: undefined,
    odometerStart: undefined,
    odometerEnd: undefined,
    distance: undefined,
    otherCosts: undefined,


  });

